// extracted by mini-css-extract-plugin
export default {"hsError":"LoginForm_hsError__XafKC","inputHolder":"LoginForm_inputHolder__WTVGH","buttonHolder":"LoginForm_buttonHolder__FMm6s"};